export const BORDER_VALUE = '2px solid hsla(0, 0%, 0%, 0.1)';
